import { defineComponent as _defineComponent } from 'vue'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import { OzMenuRowsRowStyle, type OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import { SubmissionRequestRedirectLocation, useSurfaceShareLinksStore } from '@@/pinia/surface_share_links'
import SurfaceRowDropdown from '@@/vuecomponents/SurfaceRowDropdown.vue'
import { __ } from 'bits/intl'
import OzRowToggle from 'library/v4/components/OzRowToggle.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanelSubmissionRequestSettingsSection',
  setup(__props) {

const { isDarkMode } = storeToRefs(useDarkModeStore())
const surfaceShareLinksStore = useSurfaceShareLinksStore()
const { isSubmissionRequestEnabled, submissionRequestRequiresLogin, submissionRequestRedirectLocation } =
  storeToRefs(surfaceShareLinksStore)
const { enqueueToggleSubmissionRequestRequiresLogin, enqueueUpdateSubmissionRequestRedirectLocation } =
  surfaceShareLinksStore

const redirectLocationOptions = {
  [SubmissionRequestRedirectLocation.Padlet]: {
    short: __('Open padlet'),
    title: __('Open padlet'),
    testId: 'submissionRequestOpenPadletDropdownRow',
  },
  [SubmissionRequestRedirectLocation.Confirmation]: {
    short: __('Confirmation page'),
    title: __('Open confirmation page'),
    testId: 'submissionRequestConfirmationPageDropdownRow',
  },
  [SubmissionRequestRedirectLocation.RequestAgain]: {
    short: __('Another post'),
    title: __('Add another post'),
    testId: 'submissionRequestAnotherPostDropdownRow',
  },
}

const redirectLocationRows = computed(() =>
  Object.entries(
    redirectLocationOptions as Record<
      SubmissionRequestRedirectLocation,
      { short: string; title: string; testId: string }
    >,
  ).map(([option, value]) => {
    return {
      text: value.title,
      rightIcon: option === submissionRequestRedirectLocation.value ? 'radio_selected' : 'radio_unselected',
      rightIconSize: 24,
      rightIconHighlighted: option === submissionRequestRedirectLocation.value,
      rowStyle: OzMenuRowsRowStyle.Default,
      ariaChecked: String(option === submissionRequestRedirectLocation.value),
      eventPayload: option,
      testId: value.testId,
    } as OzMenuRowsRow<SubmissionRequestRedirectLocation>
  }),
)

const onRowSelect = (_event, payload: SubmissionRequestRedirectLocation) => {
  enqueueUpdateSubmissionRequestRedirectLocation(payload)
}

return { __sfc: true,isDarkMode, surfaceShareLinksStore, isSubmissionRequestEnabled, submissionRequestRequiresLogin, submissionRequestRedirectLocation, enqueueToggleSubmissionRequestRequiresLogin, enqueueUpdateSubmissionRequestRedirectLocation, redirectLocationOptions, redirectLocationRows, onRowSelect, OzBox, OzBoxColors, OzDivider, OzDividerColorScheme, SurfaceRowDropdown, __, OzRowToggle }
}

})